module.exports = __webpack_public_path__ + "img/gamegenreproblems00.091ada8d.jpg";